import { Pipe, PipeTransform } from '@angular/core';
import { delphiTColorToHex } from '../../core/utils/color.util';

@Pipe({
  name: 'delphiColor',
  standalone: false
})
export class DelphiColorPipe implements PipeTransform {
  transform(value: unknown, fallback: string = '#FFFFFF'): string {
    return delphiTColorToHex(value, fallback);
  }
}
